/*
 * @Author: your name
 * @Date: 2021-08-26 21:17:35
 * @LastEditTime: 2023-02-16 18:32:17
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /weapp-passportweb/src/routes/m/forgetPasswordStep3.tsx
 */
import { Suspense, ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import {
    MForgetPasswordStep3
} from '../../lib';

function RouteForgetPasswordStep3(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <>
            <Route weId={`${props.weId || ''}_mrxuw2`} path={`${parentPath}/passport/oldPassword/do`} component={MForgetPasswordStep3} />
        </>
    )
}

export default withRouter(RouteForgetPasswordStep3);
